export const API_PATH = {
  PARTNER_LIST: getV1Path("partner/list"),
  ROLE_LIST: getV1Path("role/list"),
  USER_INFO: getV1Path("user/detail"),
  LOGIN: getV1Path("user/login"),
  CHANGE_PASS: getV1Path("user/change-password"),
  NOTI_LIST: getVersionPath("notification/overview", "v1"),
};

export const GENERAL = {
  GENERAL_DATA: getV1Path("report/revenue/trending"),
  TRANSACTION_REPORT: getV1Path("transaction/retrieve-report"),
  TRANSACTION_DETAIL_REPORT: getV1Path("transaction/retrieve-detail-report"),
};

export const FILTER = {
  OVERVIEW_SERVICE: getV1Path("filter/overview-service"),
};

export const STORE_API = {
  LIST: getV1Path("store/list"),
};

export const USER_MANAGEMENT = {
  USER_LIST: getV1Path("user/list"),
  UPDATE_USER: getV1Path("user/update-user"),
  CREATE_USER: getV1Path("user/create-user"),
  RESET_PASSWORD: getV1Path("user/reset-password"),
};

export const USER_MANAGEMENT_V2 = {
  USER_LIST: getVersionPath("user/list", "v2"),
};

export const PATH_CONFIG = {
  LIST: getV1Path("config"),
  CREATE_CONFIG: getV1Path("config/create"),
  UPDATE_CONFIG: getV1Path("config/update"),
  DELETE_CONFIG: getV1Path("config/delete"),
  CONFIG_DETAIL: getV1Path("config/detail"),
};

export const CONTENT_MANAGEMENT = {
  LIST: getV1Path("content/list-content-cms"),
  CREATE_CONTENT: getV1Path("content/create-content"),
  UPDATE_CONTENT: getV1Path("content/update-content"),
  DELETE_CONTENT: getV1Path("content/delete-content"),
};

export const COUNTRY_MANAGEMENT = {
  LIST: getV1Path("country/list-country"),
  CREATE_COUNTRY: getV1Path("country/create-country"),
  UPDATE_COUNTRY: getV1Path("country/update-country"),
  DETAIL: getV1Path("country/detail-country"),
  DELETE: getV1Path("country/delete-country"),
};

export const ROAMING_MANAGEMENT = {
  LIST: getV1Path("mobiledata/list-mobiledata"),
  DETAIL: getV1Path("mobileData/detail"),
  CREATE: getV1Path("mobileData/create"),
  DELETE: getV1Path("mobileData/delete"),
  UPDATE: getV1Path("mobileData/update"),
  PARTNER_LIST_ROAMING: getV1Path("roaming/partner/list-roaming-partner"),
};

export const TOPUP_MANAGEMENT = {
  LIST: getV1Path("mobiledata/list-mobiledata"),
  DETAIL: getV1Path("mobileData"),
  CREATE: getV1Path("mobileData/create"),
  DELETE: getV1Path("mobileData/delete"),
  UPDATE: getV1Path("mobileData"),
  LIST_B2B: getV1Path("mobileData/listSyncMobileData"),
  IMPORT_FROM_B2B: getV1Path("mobileData/importArray"),
  CREATEV2: getVersionPath("mobileData/create", "v2"),
  UPDATEV2: getVersionPath("mobileData", "v2"),
  ADD_SUPPLIER: getVersionPath("mobileData/supplier", "v1"),
  ADD_CATEGORY: getVersionPath("mobileData/category", "v1"),
};

export const FILE_MANAGEMENT = {
  LIST: getV1Path("file/list-file"),
  UPLOAD_FILE: getV1Path("file/upload-file"),
  REPLACE_FILE: getV1Path("file/replace-file"),
  DELETE_FILE: getV1Path("/file/delete-file"),
};

export const ADDRESS_PATH = {
  PROVINCE_LIST: getV1Path("address/list-provinces"),
  PROVINCE_DETAIL: getV1Path("address/detail-provinces"),
  UPDATE_PROVINCE: getV1Path("address/update-provinces"),
  CREATE_PROVINCE: getV1Path("address/create-provinces"),
  DELETE_PROVINCE: getV1Path("address/delete-provinces"),
  DISTRICT_LIST: getV1Path("address/list-districts"),
  DISTRICT_DETAIL: getV1Path("address/detail-districts"),
  UPDATE_DISTRICT: getV1Path("address/update-districts"),
  CREATE_DISTRICT: getV1Path("address/create-districts"),
  DELETE_DISTRICT: getV1Path("address/delete-districts"),
  WARD_LIST: getV1Path("address/list-wards"),
  WARD_DETAIL: getV1Path("address/detail-wards"),
  UPDATE_WARD: getV1Path("address/update-wards"),
  CREATE_WARD: getV1Path("address/create-wards"),
  DELETE_WARD: getV1Path("address/delete-wards"),
  REGIONS: getV1Path("address/list-administrative-regions"),
  UNITS: getV1Path("address/list-administrative-units"),
};

export const PACKAGES_REGISTRAION = {
  PACKAGES_BY_PHONE: getVersionPath("mobile/data/phone", "v3"),
  DEFAULT_PACKAGE: getV1Path("mobile/data/packages"),
  REGISTER: getV1Path("mobile/data/transaction/topup"),
};

export const PARTNER_MANAGEMENT = {
  LIST: getVersionPath("partner/list", "v2"),
  DETAIL: getVersionPath("partner/detail", "v2"),
  UPDATE: getVersionPath("partner/update", "v2"),
  CREATE: getVersionPath("partner/create", "v2"),
};

export const BALANCE_TICKET = {
  LIST: getVersionPath("ticket/list", "v1"),
  DETAIL: getVersionPath("ticket/detail", "v1"),
  UPDATE: getVersionPath("ticket/update", "v1"),
  CREATE: getVersionPath("ticket/create", "v1"),
};

export const ROAMING_PARTNER = {
  LIST: getVersionPath("roaming/partner/list-roaming-partner", "v1"),
  DETAIL: getVersionPath("roaming/partner/detail-roaming-partner", "v1"),
  UPDATE: getVersionPath("roaming/partner/update-roaming-partner", "v1"),
  CREATE: getVersionPath("roaming/partner/create-roaming-partner", "v1"),
  DELETE: getVersionPath("roaming/partner/delete-roaming-partner", "v1"),
};

export const SERVICE_MANAGEMENT = {
  LIST: getVersionPath("service/list", "v1"),
  DETAIL: getVersionPath("service/detail", "v1"),
  CREATE: getVersionPath("service/create", "v1"),
  UPDATE: getVersionPath("service/update", "v1"),
  DELETE: getVersionPath("service/delete", "v1"),
  GROUP: getVersionPath("group/list", "v1"),
};

export const CATEGORY_MANAGEMENT = {
  LIST: getVersionPath("category/list-category", "v1"),
  DETAIL: getVersionPath("category/detail-category", "v1"),
  CREATE: getVersionPath("category/create-category", "v1"),
  UPDATE: getVersionPath("category/update-category", "v1"),
  DELETE: getVersionPath("category/delete-category", "v1"),
  LIST_V2: getVersionPath("category/list-category", "v2"),
};

export const TRAVEL_SIM = {
  LIST: getV1Path("profile/list"),
  DETAIL: getV1Path("profile/find"),
};

export const TRAVEL_SIM_PROFILE = {
  LIST: getVersionPath("profile/list-profile-transaction", "v1"),
  DETAIL: getVersionPath("profile/detail-profile-transaction", "v1"),
  APPROVE: getVersionPath("infomation/connection/approve", "v1"),
};

export const APP_PROFILE_REGISTER = {
  LIST: getVersionPath("contract/list", "v1"),
  DETAIL: getVersionPath("contract/", "v1"),
  VERIFY: getVersionPath("contract/verified", "v2"),
  SYNC_STATUS: (id?: string) =>
    `${getVersionPath("contract/", "v3")}${id}/sync-status`,
  SYNC_ALL_STATUS: getVersionPath("contract/sync-all-status", "v1"),
};

export const APP_TRANSACTION = {
  LIST: getVersionPath("transaction/list-transaction", "v1"),
  DETAIL: getVersionPath("transaction/detail-transaction", "v1"),
  CHECK_STATUS: getVersionPath("transaction/check-transaction", "v1"),
};

export const TRANSACTION_HISTORY = {
  MOBISIMLIST: getVersionPath("transaction/overview-sim-ecommerce", "v1"),
  NICESIMLIST: getVersionPath("transaction/overview-nice-sim", "v1"),
  PACKAGELIST: getVersionPath("transaction/overview-package", "v1"),
  INBOUNDLIST: getVersionPath("transaction/overview-travel-sim-inbound", "v1"),
  OUTBOUNDLIST: getVersionPath(
    "transaction/overview-travel-sim-outbound",
    "v1"
  ),
  CASHFLOWLIST: getVersionPath("transaction/overview-cash-flow", "v1"),
  AIRTIMELIST: getVersionPath("transaction/overview-airtime", "v1"),
};

export const APP_FEEDBACK = {
  LIST: getVersionPath("feedback", "v1"),
  DETAIL: getVersionPath("feedback", "v1"),
};

export const PAYMENT_METHOD = {
  LIST: getVersionPath("payment/methods/management/list-payment-methods", "v1"),
  DETAIL: getVersionPath(
    "payment/methods/management/detail-payment-methods",
    "v1"
  ),
  CREATE: getVersionPath(
    "payment/methods/management/create-payment-methods",
    "v1"
  ),
  UPDATE: getVersionPath(
    "payment/methods/management/update-payment-methods",
    "v1"
  ),
  DELETE: getVersionPath(
    "payment/methods/management/delete-payment-methods",
    "v1"
  ),
};

export const SUPPLIER_MANAGEMENT = {
  LIST: getVersionPath("suppliers/management/list-supplier", "v1"),
  DETAIL: getVersionPath("suppliers/management/detail-supplier", "v1"),
  CREATE: getVersionPath("suppliers/management/create-supplier", "v1"),
  UPDATE: getVersionPath("suppliers/management/update-supplier", "v1"),
  DELETE: getVersionPath("suppliers/management/delete-supplier", "v1"),
};

export const AIRTIME_MANAGEMENT = {
  LIST: getVersionPath("airtime/list", "v1"),
  DETAIL: getVersionPath("airtime/detail/", "v1"),
  CREATE: getVersionPath("airtime/create", "v1"),
  UPDATE: getVersionPath("airtime/update", "v1"),
  DELETE: getVersionPath("airtime/delete", "v1"),
};

export const DISCOUNT_MANAGEMENT = {
  LIST: getVersionPath("commission/list", "v1"),
  DETAIL: getVersionPath("commission/detail/", "v1"),
  CREATE: getVersionPath("commission/create", "v1"),
  UPDATE: getVersionPath("commission/update", "v1"),
  DELETE: getVersionPath("commission/delete", "v1"),
};

export const PRODUCT_MANAGEMENT = {
  LIST: getVersionPath("product/listProduct", "v1"),
};

export const CARRIER_MANAGEMENT = {
  LIST: getVersionPath("carrier/list", "v1"),
};

export const RESET_OTP = {
  RESET: getVersionPath("user/reset-otp", "v1"),
};

export const USER_APP_MANAGEMENT = (detailId: string) => {
  return {
    LIST: getVersionPath("user/list", "v1"),
    DETAIL: getVersionPath(`user/${detailId}/profile`, "v1"),
  };
};

export const SIM_MANAGEMENT = {
  LIST: getVersionPath("sim/list", "v1"),
  DETAIL: getVersionPath("sim/detail", "v1"),
  IMPORT_TABLE_TEMPLATE: getVersionPath("template/import/sim/config", "v1"),
  IMPORT_SIM: getVersionPath("import/sim", "v1"),
  IMPORT_FILE_TEMPLATE: getVersionPath("template/import/sim", "v1"),
};

export const SUPPORT_FEATURE = {
  VIEW_PLAN: getVersionPath("support/view-plan", "v1"),
  VIEW_SIM: getVersionPath("support/view-sim", "v1"),
  NOTICE: getVersionPath("support/overview-notice", "v1"),
  API_DOCUMENT: getVersionPath("support/overview-api-document", "v1"),
  OFFICIAL_DISPATCH: getVersionPath("support/overview-notice", "v1"),
};

export const FILTER_FEATURE = {
  SERVICE_LIST: getVersionPath("filter/overview-service", "v1"),
  CARRIER_LIST: getVersionPath("filter/overview-carrier", "v1"),
  PACKAGE_LIST: getVersionPath("filter/overview-package", "v1"),
  NATION_LIST: getVersionPath("filter/overview-nation", "v1"),
  NUMER_TYPE_LIST: getVersionPath("filter/overview-number-type", "v1"),
};

function getV1Path(path: String) {
  return `${process.env.REACT_APP_BASE_URL}/api/v1/${path}`;
}

function getVersionPath(path: String, version: string) {
  return `${process.env.REACT_APP_BASE_URL}/api/${version}/${path}`;
}
